module.exports = __webpack_public_path__ + "img/r2gaming.bd070c87.jpg";